// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"9bd710b7","458":"cfae54c0","925":"3e7deb3e"}[chunkId] + ".chunk.css";
};